import settingsEnums from '../enums/settings'

const formatSettings = (settings: any) => {
	return Object.keys(settings).map((key: string) => {
		let settingKey = key
		let settingValue = settings[key]

		if (key === 'timerMode') {
			settingKey = 'isTimerDisabled'
			settingValue = settings[key]
		}

		const settingItem: any = {
			id: settingKey,
			value: settingValue,
		}

		if (key === 'timerMode' && settings[key] === settingsEnums.SETTING_TIMER_DISABLED_FROM_CREATION) {
			settingItem.locked = true
		}

		return settingItem
	})
}

const getSettingValue = (settings: any[], settingId: string) => {
	const setting = settings.find((setting) => setting.id === settingId) || { value: '' }
	return setting.value
}

export default {
	formatSettings,
	getSettingValue,
}
